import React, { Component } from 'react';
import { connect } from 'react-redux';
import { OrderedMap } from 'immutable';
import Policy from './Policy';

class Policies extends Component {
  constructor(props) {
    super(props);
    this.state = { policies: OrderedMap({ [0]: {} }) };
  }

  handleUpdateForm = (key, attributes) => {
    this.setState({ policies: this.state.policies.merge({ [key]: attributes }) });
    this.props.updateForm(this.state.policies.toList());
  };

  addAnotherPolicy = () => {
    this.setState({ policies: this.state.policies.merge({ [this.state.policies.size]: {} }) });
  };

  removePolicy = (key) => {
    this.setState({ policies: this.state.policies.delete(key) });
  };

  render() {
    if (!this.props.result.size) {
      return <div></div>;
    }

    return (
      <div>
        {this.state.policies.mapEntries(([key, value]) =>
          [
            key,
            <Policy
              key={key}
              policies={this.props.policies}
              result={this.props.result}
              updateForm={this.handleUpdateForm.bind(this, key)}
              addAnotherPolicy={this.addAnotherPolicy}
            />,
          ]
        ).toList()}
      </div>
    );

  }
};

function mapStateToProps(state) {
  return {
    policies: state.get('policies').get('items'),
    result: state.get('policies').get('result'),
    isFetching: state.get('policies').get('isFetching'),
  };
}

export default connect(mapStateToProps)(Policies);



/** WEBPACK FOOTER **
 ** ./components/forms/Policies.js
 **/